'use client'

import {LegendItem} from './LegendItem'
import {type ChartProps} from './types'
import {lazy, Suspense} from 'react'

const BarChart = lazy(async () => await import('./BarChart'))

const Chart = ({
  label,
  color,
  data,
  category,
  reverseOrientation,
  legendItemSubLabel,
  ...barChartProps
}: ChartProps) => {
  return (
    <div className="flex flex-1 flex-col border-solid border-border-frosted">
      <LegendItem
        label={label}
        color={color}
        subLabel={legendItemSubLabel}
        reverseOrientation={reverseOrientation}
      />
      <div className="h-[312px] w-full">
        <Suspense fallback={null}>
          <BarChart
            {...barChartProps}
            data={data}
            category={category}
            color={color}
            reverseOrientation={reverseOrientation}
          />
        </Suspense>
      </div>
    </div>
  )
}

export default Chart
